import { iacOptionInterface } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import { enduserInterface } from './enduser';

export interface requestClassificationInterface {
	serviceType: serviceTypeInterface[];
	scope: scopeInterface[];
	category: categoryInterface[];
	topic: topicInterface[];
	solutionArea: solutionAreaInterface[];

	analysts?: enduserInterface[];

	impact: impactInterface[];
	urgency: urgencyInterface[];
	severity: severityInterface[];

	changeType?: changeTypeInterface[];
	riskType?: riskTypeInterface[];

	solutionAreaIAC?: iacOptionInterface[];
	serviceTypeIAC?: iacOptionInterface[];
	scopeIAC?: iacOptionInterface[];
	categoryIAC?: iacOptionInterface[];
	topicIAC?: iacOptionInterface[];
	impactIAC?: iacOptionInterface[];
	urgencyIAC?: iacOptionInterface[];
	severityIAC?: iacOptionInterface[];
	changeTypeIAC?: iacOptionInterface[];
	riskTypeIAC?: iacOptionInterface[];
}
export type SERVICE_TYPES = keyof typeof SERVICE_TYPES_ENUM;
export enum SERVICE_TYPES_ENUM {
	PROBLEM = '1',
	INCIDENT = '2',
	CHANGE = '3',
	COMPLAINT = '5',
	SERVICE_REQUEST = '6',
}
export const ALL_SERVICE_TYPES = Object.keys(SERVICE_TYPES_ENUM) as SERVICE_TYPES[];
export interface serviceTypeInterface {
	id: string;
	name: string;
	label: string;
}

export interface scopeInterface {
	id: string;
	name: string;
	label: string;
	service_type?: serviceTypeInterface;
	allowedCiTypes?: number[];
	mandatoryCiBinding?: boolean;
}

export interface categoryInterface {
	id: string;
	name: string;
	label: string;
	scope?: scopeInterface;
}

export interface topicInterface {
	id: string;
	name: string;
	label: string;
	category?: categoryInterface;
}

export interface solutionAreaInterface {
	id: string;
	name: string;
	label?: string;
	topic?: topicInterface;
	customer?: string;
	group_name?: string;
}

export interface impactInterface {
	id: string;
	name: string;
	label: string;
	impact: string;
	default: boolean;
	default_classification?: boolean;
}

export interface urgencyInterface {
	id: string;
	name: string;
	label: string;
	urgency: string;
	default: boolean;
	default_classification?: boolean;
}
export interface severityInterface {
	id: string;
	name: string;
	label: string;
	severity: string;
	topic?: topicInterface;
	solutionArea?: solutionAreaInterface;
}

export interface changeTypeInterface {
	id: string;
	name: string;
	label: string;
}

export interface riskTypeInterface {
	id: string;
	name: string;
	label: string;
}
